module.exports = __webpack_public_path__ + "img/serviceimg.275c688d.jpg";